import * as actionTypes from 'containers/PageHeader/ExportModal/action-types';
import { CURRENT_PAGE_EXPORT, RAW_WEEKLY_EXPORT } from 'utils/strings';

const initialState = {
  email: 'mail@mail.com',
  typeOfExport: {
    currentPage: false,
    rawWeekly: false,
  },
  selection: {
    pdf: false,
    xls: false,
  },
  show: false,
  isExportState: false,
  isLoadingState: false,
  exportResult: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.EMAIL_CHANGE:
      return {
        ...state,
        email: action.payload,
      };
    case actionTypes.OPEN:
      return {
        ...state,
        email: action.payload || initialState.email,
        selection: { ...initialState.selection },
        show: true,
      };
    case actionTypes.SELECTION_SET:
      return {
        ...state,
        selection: {
          ...state.selection,
          [action.payload]: !state.selection[action.payload],
        },
      };
    case actionTypes.SET_EXPORT_TYPE:
      return {
        ...state,
        typeOfExport: {
          currentPage: action.payload === CURRENT_PAGE_EXPORT,
          rawWeekly: action.payload === RAW_WEEKLY_EXPORT,
        },
        selection: {
          ...state.selection,
          xls: action.payload === RAW_WEEKLY_EXPORT,
        },
      };
    case actionTypes.RESET_EXPORT_TYPE:
      return {
        ...state,
        typeOfExport: {
          currentPage: false,
          rawWeekly: false,
        },
        selection: {
          pdf: false,
          xls: false,
        },
      };
    case actionTypes.SHOW:
      return {
        ...state,
        show: action.payload,
      };
    case actionTypes.IS_LOADING_STATE_SET:
      return {
        ...state,
        isLoadingState: action.payload,
      };
    case actionTypes.IS_EXPORT_STATE_SET:
      return {
        ...state,
        isExportState: action.payload,
      };
    case actionTypes.EXPORT_RESULT_SET:
      return {
        ...state,
        exportResult: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
